import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Remove any external watermarks
const removeWatermarks = () => {
  const selectors = [
    'a[href*="emergent"]',
    'div[style*="Emergent"]',
    '[class*="emergent"]',
    '[data-emergent]'
  ];
  selectors.forEach(selector => {
    document.querySelectorAll(selector).forEach(el => {
      el.style.display = 'none';
      el.remove();
    });
  });
};

// Run on load and observe for dynamic additions
setTimeout(removeWatermarks, 100);
setTimeout(removeWatermarks, 500);
setTimeout(removeWatermarks, 1000);

const observer = new MutationObserver(removeWatermarks);
observer.observe(document.body, { childList: true, subtree: true });

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
